import { actionWillPush, LISTING_ACTION_MAX_LENGTH } from '@pulsify/shared'
import type { CreateListingActionRequest } from '@pulsify/shared/dto'
import { type ActionEndChoice, actionEndsAt, isActionEndChoiceValid } from './action-end'

export type ActionComposerProblem = 'empty' | 'too_long' | 'end_passed'

/** Why the composer cannot send yet, or null when it can. */
export function actionComposerProblem(
  text: string,
  choice: ActionEndChoice,
  now: Date,
): ActionComposerProblem | null {
  const trimmed = text.trim()
  if (trimmed.length === 0) return 'empty'
  if (trimmed.length > LISTING_ACTION_MAX_LENGTH) return 'too_long'
  return isActionEndChoiceValid(choice, now) ? null : 'end_passed'
}

/** Whether the push still reaches the Favoriten: an action that ends before 08:00 sends none. */
export function actionReachesFavorites(choice: ActionEndChoice, now: Date): boolean {
  return actionWillPush(actionEndsAt(choice, now), now)
}

export function toCreateActionRequest(
  text: string,
  choice: ActionEndChoice,
  now: Date,
): CreateListingActionRequest {
  return { text: text.trim(), endsAt: actionEndsAt(choice, now).toISOString() }
}
